import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/msalInstance";
import { DOMINICUS_LOGO_URL } from "../brand";

export default function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src={DOMINICUS_LOGO_URL} alt="Dominicus Amsterdam" width={200} height={56} />
        </div>
        <h1 className="login-title">Adresboek Dominicus</h1>
        <p className="login-subtitle">Dominicus Amsterdam</p>
        <p className="login-desc">
          Adresboek en contactbeheer voor onze gemeenschap.
        </p>
        <button className="btn-microsoft" onClick={handleLogin}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" width="20" height="20">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Aanmelden met Microsoft
        </button>
        <p className="login-footer">
          Gebruik je Dominicus Amsterdam Microsoft-account
        </p>
      </div>
    </div>
  );
}
